import React from "react";
import { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import "../../styles/login.css";
import {
  IconButton,
  Typography,
  FormGroup,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import { automationHttpRequest } from "../../api/httpRequests";
import { Divider } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { Select, MenuItem, InputAdornment, TextField } from "@mui/material";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import Paper from "@mui/material/Paper";
import { ReactComponent as Success } from "../../assets/images/Success.svg";
import Box from "@mui/material/Box";
import axios from "axios";
import { ReactComponent as ButtonPlus } from "../../assets/images/ButtonPlus.svg";
import backgroundImg from "../../assets/images/circleBackground.png";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToastContainer, toast } from "react-toastify";
import PartExtensionSuccess from "./PartExtensionSuccess";

const PartExtension = ({
  materialNumber,
  handleDialogClose,
  uid,
  handleBackClick,
  handleBack,
  handleDialogOpen,
  callFromCreationScreen,
}) => {
  const [successPop, setSuccessPop] = useState(false);
  const [inputCount, setInputCount] = useState(1);
  const [inputValues, setInputValues] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [justificationShow, setJustificationShow] = useState(false);
  const [justificationShowMin, setJustificationShowMin] = useState(false);
  const [justificationShowMax, setJustificationShowMax] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [requestID, setRequestID] = useState(0);
  const [leadTimeValue, setLeadTimeValue] = useState("");
  const [netPrice, setNetPrice] = useState("");
  const [vendorNumber, setVendorNumber] = useState("");
  const [vendorMaterialNumber, setVendorMaterialNumber] = useState("");
  const [abcIndicator, setAbcIndicator] = useState({
    abcIndicatorFutureValue: "",
    abcIndicatorJustify: "",
  });
  const [partCreationDialog, setPartCreationDialog] = useState(false);
  const [location, setLocation] = useState("");
  const [criticalityIndicator, setCriticalityIndicator] = useState("");
  const [bin, setBin] = useState("");
  const [minimumValue, setMinimumValue] = useState({
    minimumValueFutureValue: "",
    minimumValueJustify: "",
  });
  const [maximumValue, setMaximumValue] = useState({
    maximumValueFutureValue: "",
    maximumValueJustify: "",
  });
  const [vendorNames, setVendorNames] = useState([]);
  const [optionToShow, setOptionToShow] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [duplicateRequestBlocked, setDuplicateRequestBlocked] = useState(false);
  const [duplicateRequestMessage, setDuplicateRequestMessage] = useState("");
  const hasFetchedExtensionRef = useRef(false);
  // const [checked, setChecked] = useState(false)

  const options = ["USD", "CAD", "EUR", "GBP", "JPY"];

  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];

  const uomOptions = [
    "DZ",
    "FT",
    "RL",
    "MIL",
    "M",
    "TH",
    "BOX",
    "DR",
    "BTE",
    "KG",
    "BAG",
    "L",
    "EA",
    "PAK",
    "PAC",
    "GLL",
    "PAA",
    "CS",
    "LB",
    "PAQ",
  ];
  const [currency, setCurrency] = useState(options[0]);
  const [orderUnit, setOrderUnit] = useState(uomOptions[0]);

  useEffect(() => {
    let hasValue = false;
    for (let i = 0; i < inputValues.length; i++) {
      if (inputValues[i] !== "") {
        hasValue = true;
        break;
      }
    }
    if (
      hasValue &&
      maximumValue?.maximumValueFutureValue > 0 &&
      abcIndicator?.abcIndicatorFutureValue.length > 0 &&
      (minimumValue?.minimumValueFutureValue === 0 ||
        minimumValue?.minimumValueFutureValue > 0) &&
      minimumValue?.minimumValueFutureValue <=
        maximumValue?.maximumValueFutureValue &&
      vendorMaterialNumber &&
      vendorMaterialNumber?.trim() !== "" &&
      vendorMaterialNumber?.length > 0 &&
      location?.length > 0 &&
      vendorNumber &&
      vendorNumber?.length > 0 &&
      leadTimeValue >= 0 &&
      netPrice >= 0 &&
      leadTimeValue !== "" &&
      netPrice !== "" &&
      orderUnit !== "" &&
      !duplicateRequestBlocked
    ) {
      setSubmitButton(true);
    } else {
      setSubmitButton(false);
    }
  }, [
    maximumValue?.maximumValueFutureValue,
    inputValues,
    vendorMaterialNumber,
    abcIndicator?.abcIndicatorFutureValue,
    minimumValue?.minimumValueFutureValue,
    location,
    leadTimeValue,
    vendorNumber,
    netPrice,
    orderUnit,
    duplicateRequestBlocked,
  ]);

  const handleSelectChange = (event) => {
    setCurrency(event?.target?.value);
    // setSubmitButton(true);
  };

  const handleSelectABCChange = (event) => {
    setAbcIndicator((prevObject) => ({
      ...prevObject,
      abcIndicatorFutureValue: event?.target?.value,
    }));
    setJustificationShow(true);
  };

  useEffect(() => {
    fetchVendorNames();
  }, []);

  const fetchVendorNames = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.post(
        "/get_vendor_details/",
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        },
      );
      if (response?.data?.status) {
        setVendorNames(response?.data?.data);
        setOptionToShow(response?.data?.data.slice(0, 200));
        setFetching(false);
      }
    } catch (error) {
      console.error("Error fetching nouns:", error);
    }
  };

  useEffect(() => {
    if (hasFetchedExtensionRef.current) {
      return;
    }
    hasFetchedExtensionRef.current = true;
    fetchSearchResult();
  }, []);

  useEffect(() => {
    if (responseData) {
      setLocation(responseData?.storage_location);
      // setBin(responseData?.storage_bin);
      setCriticalityIndicator(responseData?.critical_part);
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: "",
      }));
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueFutureValue:
          parseInt(responseData?.future_minimum_stock_level) || "",
      }));
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueFutureValue:
          parseInt(responseData?.future_maximum_stock_level) || "",
      }));
    }
    setNetPrice(responseData?.standard_price);
    setVendorNumber(responseData?.vendor_account);
    setVendorMaterialNumber(responseData?.supplier_part_number);
    setLeadTimeValue(responseData?.lead_time_from_pir);
    setOrderUnit(responseData?.order_unit_from_pir || "");
  }, [responseData]);

  const handleOrderUnit = (event) => {
    setOrderUnit(event?.target?.value);
  };

  const initialValue = {
    plant: "",
    purchasingGroup: "",
    baseUnitOfMeasure: "",
    mrpGroup: "",
    mrpController: "",
    abcIndicator: "",
    criticalityIndicator: "",
    safetyStock: "",
    maximumStock: "",
    sloc: "",
    bin: "",
  };

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  };

  const headingStyle = {
    fontFamily: "Verdana",
    fontWeight: "700",
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  const fetchSearchResult = async () => {
    setLoading(true);
    try {
      const response = await automationHttpRequest.post(
        "/extension/",
        {
          // Unique_ID: uid.toString(),
          // "material_number": materialNumber
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            material_number: materialNumber,
            plant_id: localStorage.getItem("MRO_user_plantId"),
            Unique_ID: uid.toString(),
          },
        },
      );
      if (response?.data?.status) {
        setDuplicateRequestBlocked(false);
        setDuplicateRequestMessage("");
        setResponseData(response?.data?.data[0]);
        setLoading(false);
      } else {
        const apiMessage =
          response?.data?.data ||
          "Unable to process the request. Please try again!";
        setDuplicateRequestBlocked(true);
        setDuplicateRequestMessage(apiMessage);
        setLoading(false);
        toast.error(apiMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1200,
        });
        if (typeof handleDialogClose === "function") {
          handleDialogClose();
        } else if (typeof handleBackClick === "function") {
          handleBackClick();
        }
      }
    } catch (error) {
      setDuplicateRequestBlocked(true);
      setDuplicateRequestMessage(
        "Unable to process the request. Please try again!",
      );
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
      if (typeof handleDialogClose === "function") {
        handleDialogClose();
      } else if (typeof handleBackClick === "function") {
        handleBackClick();
      }
    }
  };

  // const handleClose = () => {
  //   handleDialogClose();
  // };

  const handleSubmit = async () => {
    if (duplicateRequestBlocked) {
      return;
    }
    handleSubmitValues();
  };

  const handleReset = async () => {
    setInputValues([""]);
    setAbcIndicator({
      abcIndicatorFutureValue: "",
      abcIndicatorJustify: "",
    });
    setMinimumValue({
      minimumValueFutureValue: "",
      minimumValueJustify: "",
    });
    setMaximumValue({
      maximumValueFutureValue: "",
      maximumValueJustify: "",
    });
    setLocation(responseData?.storage_location);
    // setBin(responseData?.storage_bin);
    setBin("");
    setCriticalityIndicator(responseData?.critical_part);
  };

  const handleSubmitValues = async () => {
    const finalValue = {
      material_number: materialNumber,
      vendor_account: vendorNumber || 0,
      plant_Id: localStorage.getItem("MRO_user_plantId"),
      supplier_part_number: vendorMaterialNumber || "",
      lead_time_from_pir: `${parseInt(leadTimeValue) || 0} Days`,
      order_unit_from_pir: orderUnit || "",
      ABC_indicator: responseData?.ABC_indicator || "",
      critical_part: criticalityIndicator || responseData?.critical_part || "",
      minimum_stock_level: responseData?.minimum_stock_level || 0,
      maximum_stock_level: responseData?.maximum_stock_level || 0,
      storage_location: location || "-",
      storage_bin: bin || "-",
      currency,
      equipment_number_for_bom: inputValues,
      standard_price: parseFloat(netPrice) || 0,
      future_abc_indicator: abcIndicator?.abcIndicatorFutureValue || "",
      future_maximum_stock_level:
        parseInt(maximumValue?.maximumValueFutureValue) || 0,
      future_minimum_stock_level:
        parseInt(minimumValue?.minimumValueFutureValue) || 0,
      justification_for_change_in_abc_indicator:
        abcIndicator?.abcIndicatorJustify || "",
      justification_for_change_in_maximum_stock:
        maximumValue?.maximumValueJustify || "",
      justification_for_change_in_minimum_stock:
        minimumValue?.minimumValueJustify || "",
      plant_name: responseData?.plant_name,
      plant_id: localStorage.getItem("MRO_user_plantId"),
      submitted_by: localStorage.getItem("MRO_user_email"),
    };
    try {
      setLoading(true);
      const response = await automationHttpRequest.post(
        "/extension_insert/",
        {
          ...finalValue,
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setRequestID(response?.data?.data?.request_id);
        setSuccessPop(true);
        setLoading(false);
        setPartCreationDialog(true);
      } else {
        setSuccessPop(false);
        setLoading(false);
        toast.error(
          response?.data?.data ||
            "Unable to process the request. Please try again!",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1200,
          },
        );
      }
    } catch (error) {
      setSuccessPop(false);
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };
  const handleInputChange = (index, value) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue != "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = numericValue;
      setInputValues(newInputValues);
      // setSubmitButton(true);
    }
    if (value === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = "";
      setInputValues(newInputValues);
    }
  };

  const handleAddInput = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, ""]);
    // setSubmitButton(true);
  };

  const handleChange = (event) => {
    if (event?.target?.name === "leadTime") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setLeadTimeValue(numericValue);
      }
      if (event?.target?.value === "") {
        setLeadTimeValue("");
      }
    } else if (event?.target?.name === "vendorNumber") {
      setVendorNumber(event?.target?.value);
    } else if (event?.target?.name === "vendorMaterialNumber") {
      setVendorMaterialNumber(event?.target?.value);
    } else {
      const isValid = /^[0-9,/.\\-\s]*$/.test(event?.target?.value);
      if (isValid) {
        const numericValue = parseInt(event?.target?.value, 10);
        if (!isNaN(numericValue) && numericValue != "") {
          setNetPrice(event?.target?.value);
        }
        if (event?.target?.value === "") {
          setNetPrice("");
        }
      }
    }
    // setSubmitButton(true);
  };

  const handleFutureValue = (event) => {
    // setSubmitButton(true);
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: event?.target?.value,
      }));
      setJustificationShow(true);
    }
    if (event?.target?.name === "minimumValue") {
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumValueFutureValue: numericValue,
        }));
        setJustificationShowMin(true);
      }
      if (event?.target?.value === "") {
        setJustificationShowMin(false);
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumValueFutureValue: "",
        }));
      }
    }
    if (event?.target?.name === "maximumValue") {
      if (
        parseInt(event?.target?.value, 10) <
          parseInt(minimumValue?.minimumValueFutureValue, 10) ||
        (parseInt(event?.target?.value, 10) === 0 &&
          parseInt(minimumValue?.minimumValueFutureValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumValueFutureValue: numericValue,
        }));
        setJustificationShowMax(true);
      }
      if (event?.target?.value === "") {
        setJustificationShowMax(false);
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumValueFutureValue: "",
        }));
      }
    }
  };
  const handleJustification = (event) => {
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "minimumValue") {
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "maximumValue") {
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueJustify: event?.target?.value,
      }));
    }
  };

  const handleIndicatorSelectChange = (event) => {
    // setChecked(!checked)
    let val = event.target.checked ? "X" : "";
    setCriticalityIndicator(val);
    // setCriticalityIndicator(event?.target.value);
  };

  const handleChangeCurrent = (event) => {
    // setSubmitButton(true);
    if (event?.target?.name === "Sloc") {
      setLocation(event?.target.value);
    } else if (event?.target?.name === "CriticalityIndicator") {
      setCriticalityIndicator(event?.target.value);
    } else {
      if (event?.target.value.length <= 10) {
        setBin(event?.target.value);
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    }
  };

  const handleVendorNameChange = (val) => {
    setVendorNumber(val);
  };

  const ValueDisplay = ({
    current,
    future,
    justification,
    currentValue,
    disabled,
  }) => {
    return (
      <>
        <div>
          {current && (
            <input
              className="narrowInput"
              // placeholder="Current Value"
              name="currentValue"
              type="text"
              autoComplete="off"
              disabled={disabled}
              value={currentValue}
              style={{ background: "#EFEFEF" }}
            />
          )}
          {future && (
            <input
              // placeholder="future Value"
              name="revisedValue"
              type="text"
              className="narrowInput"
              autoComplete="off"
            />
          )}
          {justification && (
            <input
              // placeholder="Justification"
              name="justificationValue"
              type="text"
              className="narrowInput"
              autoComplete="off"
            />
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div>
        <button
          style={{
            display: "flex",
            width: "90px",
            justifyContent: "space-around",
            alignItems: "center",
            border: "0px",
            background: "transparent",
            margin: "0px 0px 20px 0px",
            cursor: "pointer",
          }}
          onClick={() => handleBackClick()}
        >
          <ArrowBackIcon />
          <Typography> Back </Typography>
        </button>
      </div>
      <div>
        {loading ? (
          <>
            <>
              <Typography
                sx={{
                  height: "70px",
                  fontSize: "18px",
                  padding: "20px",
                  background: "#EFEFEF",
                }}
              >
                Loading...
              </Typography>
            </>
          </>
        ) : (
          <>
            <div className="">
              {!successPop ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {/* <Plant /> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: "700",
                          position: "relative",
                          left: "10px",
                          fontFamily: "Verdana",
                        }}
                      >
                        Extend Part to Plant
                      </Typography>
                      <Typography style={{ fontWeight: "550" }}>
                        {responseData?.plant_name}
                      </Typography>
                      {/* <For  mControl sx={{ m: 1, width: "200px" }}>
                        <div className="select-container">
                          <input
                            // placeholder="Part Extension"
                            name="activePart"
                            style={{ background: "#EFEFEF" }}
                            type="text"
                            value={responseData?.plant_name}
                            className="partInputField"
                            disabled
                          />
                        </div>
                      </FormControl> */}
                    </div>
                  </div>
                  <Divider style={{ margin: "10px 0px" }} />
                  <div className="formikExtension">
                    <div style={inputStyle}>
                      <Typography style={headingStyle}>
                        SAP Vendor Number
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Autocomplete
                        popupIcon={
                          <DropdownIcon
                            style={{
                              width: "20px",
                              position: "relative",
                              left: "0px",
                            }}
                          />
                        }
                        id="combo-box-demo-sap"
                        options={vendorNames}
                        // disableClearable={true}
                        value={vendorNumber}
                        onChange={(e, value) => {
                          handleVendorNameChange(value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            className="formControlSelect"
                            placeholder="SAP Vendor Number"
                            {...params}
                            variant="outlined"
                          />
                        )}
                        sx={{ margin: "10px" }}
                      />
                      {/* <input
                        value={vendorNumber}
                        autoComplete="off"
                        // placeholder="Vendor Number"
                        type="text"
                        onChange={handleChange}
                        name="vendorNumber"
                        // disabled
                        // style={{ background: "#EFEFEF" }}
                        className="partInputField"
                      /> */}
                    </div>
                    <div style={inputStyle}>
                      <Typography style={headingStyle}>
                        Vendor Material Number
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <input
                        // placeholder="Vendor Material Number"
                        name="vendorMaterialNumber"
                        autoComplete="off"
                        type="text"
                        onChange={handleChange}
                        value={vendorMaterialNumber}
                        className="partInputField"
                        // disabled
                        // style={{ background: "#EFEFEF" }}
                      />
                    </div>
                    <div style={inputStyle}>
                      <Typography
                        style={{
                          fontWeight: "700",
                          position: "relative",
                          left: "10px",
                          fontFamily: "Verdana",
                        }}
                      >
                        Lead Time
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          // placeholder="Lead Time"
                          name="leadTime"
                          autoComplete="off"
                          onChange={handleChange}
                          type="text" // Change type to text
                          pattern="[0-9]*"
                          inputmode="numeric"
                          value={leadTimeValue}
                          style={{ width: "80px" }}
                          className="partInputField"
                        />
                        <FormControl
                          sx={{
                            m: 1,
                            width: "60px",
                            position: "relative",
                            left: "-10px",
                          }}
                        >
                          <TextField
                            variant="outlined"
                            value={"Days"}
                            // onChange={handleLeadTimeChange}
                            disabled
                            InputProps={{
                              sx: {
                                height: "32px",
                                borderRadius: "8px",
                                backgroundColor: "#f0f0f0", // Set the background color
                                color: "#000", // Set the text color
                                cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                                "&:hover": {
                                  backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                                },
                                width: "68px",
                              },
                            }}
                            fullWidth
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div style={inputStyle}>
                      <Typography
                        style={{
                          fontWeight: "700",
                          position: "relative",
                          left: "10px",
                          fontFamily: "Verdana",
                        }}
                      >
                        Price Unit
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <input
                          name="netPrice"
                          onChange={handleChange}
                          type="text" // Change type to text
                          pattern="[0-9,/.\\-\s]*"
                          inputmode="numeric"
                          autoComplete="off"
                          value={netPrice}
                          className="partInputField"
                          style={{ width: "80px" }}
                        />
                      </div>
                    </div>
                    <div style={inputStyle}>
                      <Typography
                        style={{
                          fontWeight: "700",
                          position: "relative",
                          left: "10px",
                          fontFamily: "Verdana",
                        }}
                      >
                        Price UOM
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>

                      <FormControl
                        sx={{
                          m: 1,
                          width: "70px",
                          marginTop: "10px",
                          position: "relative",
                          left: "10px",
                        }}
                      >
                        <Select
                          value={currency}
                          onChange={handleSelectChange}
                          sx={{
                            height: "32px",
                            borderRadius: "8px",
                            width: "100px",
                          }}
                        >
                          {options.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ ...inputStyle, marginLeft: "10px" }}>
                      <Typography style={headingStyle}>
                        Order Unit
                        <span
                          style={{
                            color: "#C6003D",
                            margin: "4px",
                            fontSize: "18px",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      {/* <input
                        // placeholder="OrderUOM"
                        name="orderUOM"
                        // disabled
                        type="text"
                        onChange={handleChange}
                        autoComplete="off"
                        value={responseData?.order_unit_from_pir}
                        className="partInputField"
                        style={{
                          // background: "#EFEFEF",
                          marginLeft: "20px",
                          width: "80px",
                        }}
                      /> */}
                      <FormControl sx={{ m: 1, width: "100px" }}>
                        <Select
                          value={orderUnit}
                          name="orderUOM"
                          onChange={handleOrderUnit}
                          MenuProps={MenuProps}
                          sx={{ height: "32px", borderRadius: "8px" }}
                        >
                          {uomOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {/* <div style={inputStyle}>
                        <Typography style={headingStyle}>ABC Indicator</Typography>
                        <input
                          placeholder="ABC Indicator"
                          name="abcIndicator"
                          onChange={handleChange}
                          type="text"
                          value={values.abcIndicator}
                          className="partInputField"
                        />
                      </div>
                      <div style={inputStyle}>
                        <Typography style={headingStyle}>Criticality Indicator</Typography>
                        <input
                          placeholder="Criticality Indicator"
                          name="criticalityIndicator"
                          onChange={handleChange}
                          type="text"
                          value={values.criticalityIndicator}
                          className="partInputField"
                        />
                      </div>
                      <div style={inputStyle}>
                        <Typography style={headingStyle}>Safety Stock</Typography>
                        <input
                          placeholder="Safety Stock"
                          name="safetyStock"
                          onChange={handleChange}
                          type="text"
                          value={values.safetyStock}
                          className="partInputField"
                        />
                      </div>
                      <div style={inputStyle}>
                        <Typography style={headingStyle}>Maximum Stock</Typography>
                        <input
                          placeholder="Maximum Stock"
                          name="maximumStock"
                          onChange={handleChange}
                          type="text"
                          value={values.maximumStock}
                          className="partInputField"
                        />
                      </div>
                      <div style={inputStyle}>
                        <Typography style={headingStyle}>Sloc</Typography>
                        <input
                          placeholder="Sloc"
                          name="sloc"
                          onChange={handleChange}
                          type="text"
                          value={values.sloc}
                          className="partInputField"
                        />
                      </div>
                      <div style={inputStyle}>
                        <Typography style={headingStyle}>Bin</Typography>
                        <input
                          placeholder="Bin"
                          name="bin"
                          onChange={handleChange}
                          type="text"
                          value={values.bin}
                          className="partInputField"
                        />
                      </div> */}
                  </div>
                  <Divider style={{ margin: "10px 0px" }} />
                  {/* {!justificationShow ? (
                    <>
                      <div
                        style={{ width: "50%", margin: "40px 0px 10px 435px" }}
                      >
                        <Typography
                          style={{ display: "inline-block", position: "relative", left: "75px",  fontWeight: 600}}
                        >
                          Current Value
                        </Typography>
                        <Typography
                          style={{
                            display: "inline-block",
                            position: "relative",
                            left: "75px",
                            fontWeight: 600,
                          }}
                        >
                          Proposed Value
                        </Typography>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "60%",
                          justifyContent: "space-evenly",
                          margin: "40px auto 0px",
                        }}
                      >
                        <Typography style={{ fontWeight: 600 }}>
                          Current Value
                        </Typography>
                        <Typography style={{ fontWeight: 600 }}>
                          Proposed Value
                        </Typography>
                        {
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: !justificationShow ? "#fff" : "#000", // Change color based on justificationShow
                            }}
                          >
                            Reason for Change
                          </Typography>
                        }
                      </div>
                    </>
                  )} */}
                  <div className="valueDisplay">
                    <Typography className="subHeading"></Typography>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontFamily: "Verdana",
                        margin: "40px 20px 10px 60px",
                      }}
                    >
                      Current Value
                    </Typography>

                    <Typography
                      style={{
                        fontWeight: 600,
                        margin: "40px 20px 10px 35px",
                        fontFamily: "Verdana",
                      }}
                    >
                      Proposed Value
                    </Typography>
                    {
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: !(
                            justificationShow ||
                            minimumValue?.minimumValueFutureValue > 0 ||
                            maximumValue?.maximumValueFutureValue > 0
                          )
                            ? "#fff"
                            : "#000", // Change color based on justificationShow
                          margin: "40px 20px 10px 110px",
                        }}
                      >
                        Reason for Change
                      </Typography>
                    }
                  </div>
                  <div className="valueDisplay">
                    <Typography className="subHeading">
                      ABC Indicator
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "18px",
                        }}
                      >
                        *
                      </span>
                    </Typography>

                    <ValueDisplay
                      current={true}
                      suggested={true}
                      future={false}
                      disabled={true}
                      justification={false}
                      currentValue={responseData?.ABC_indicator}
                    />
                    {/* <input
                      // placeholder="future Value"
                      name="abcIndicator"
                      type="text"
                      className="narrowInput"
                      value={abcIndicator?.abcIndicatorFutureValue}
                      onChange={handleFutureValue}
                    /> */}
                    <FormControl
                      sx={{ width: "100px", margin: "0px 20px 0px 70px" }}
                    >
                      <Select
                        value={abcIndicator?.abcIndicatorFutureValue}
                        onChange={handleSelectABCChange}
                        sx={{ height: "32px" }}
                      >
                        {ABCoptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {justificationShow && (
                      <input
                        // placeholder="Justify Value"
                        name="abcIndicator"
                        autoComplete="off"
                        // disabled={
                        //   abcIndicator?.abcIndicatorFutureValue?.length > 0
                        //     ? false
                        //     : true
                        // }
                        type="text"
                        className="narrowInputReason"
                        value={abcIndicator?.abcIndicatorJustify}
                        onChange={handleJustification}
                      />
                    )}
                  </div>
                  <Divider />
                  <div className="valueDisplay">
                    <Typography className="subHeading">
                      Criticality Indicator
                    </Typography>
                    <ValueDisplay
                      current={true}
                      suggested={false}
                      disabled={true}
                      future={false}
                      justification={false}
                      currentValue={responseData?.critical_part}
                    />
                    {/* <input
                      // placeholder="Sloc"
                      name="CriticalityIndicator"
                      type="text"
                      autoComplete="off"
                      className="narrowInput"
                      value={criticalityIndicator}
                      onChange={handleChangeCurrent}
                    /> */}

                    {/* <FormControl sx={{
                        borderRadius: "8px",
                        margin: "10px 20px 10px 70px !important",
                        width: "100px",
                        outlineStyle: "none",
                        border: "1px solid #cbc3c3",
                        textAlign: "center"
                      }}>
                        <Select
                          value={criticalityIndicator}
                          onChange={handleIndicatorSelectChange}
                          renderValue={(selected) => (
                            <div>
                              <span key={selected}>{selected}</span>
                            </div>
                          )}
                          sx={{
                            padding: "0px !important",
                            height: "32px"
                          }}
                        >
                          <MenuItem value="">
                            <Checkbox checked={criticalityIndicator === ""} />
                            <ListItemText primary="Blank" />
                          </MenuItem>
                          <MenuItem value="X">
                            <Checkbox checked={criticalityIndicator === "X"} />
                            <ListItemText primary="X" />
                          </MenuItem>
                        </Select>
                      </FormControl> */}
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={criticalityIndicator === "X"}
                            style={{
                              color: "#575555",
                              position: "relative",
                              left: "110px",
                            }}
                            onChange={handleIndicatorSelectChange}
                          />
                        }
                        // label="My Checkbox"
                      />
                    </FormGroup>
                  </div>
                  <Divider />
                  <div className="valueDisplay">
                    <Typography className="subHeading">
                      Minimum Stock
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "18px",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <ValueDisplay
                      current={true}
                      suggested={false}
                      future={false}
                      disabled={true}
                      justification={false}
                      currentValue={responseData?.minimum_stock_level}
                    />
                    <input
                      // placeholder="future Value"
                      name="minimumValue"
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      autoComplete="off"
                      className="narrowInput partInputFieldEq"
                      value={minimumValue?.minimumValueFutureValue}
                      onChange={handleFutureValue}
                    />
                    {(minimumValue?.minimumValueFutureValue > 0 ||
                      minimumValue?.minimumValueFutureValue === 0) && (
                      <input
                        // placeholder="Justify Value"
                        name="minimumValue"
                        type="text"
                        autoComplete="off"
                        className="narrowInputReason"
                        style={{
                          background:
                            minimumValue?.minimumValueFutureValue > 0 ||
                            minimumValue?.minimumValueFutureValue === 0
                              ? "#FFF"
                              : "#EFEFEF",
                        }}
                        value={minimumValue?.minimumValueJustify}
                        onChange={handleJustification}
                      />
                    )}
                  </div>
                  <Divider />
                  <div className="valueDisplay">
                    <Typography className="subHeading">
                      Maximum Stock
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "18px",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <ValueDisplay
                      current={true}
                      disabled={true}
                      suggested={false}
                      future={false}
                      justification={false}
                      currentValue={responseData?.maximum_stock_level}
                    />
                    <input
                      // placeholder="future Value"
                      name="maximumValue"
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      className="narrowInput partInputFieldEq"
                      autoComplete="off"
                      value={maximumValue?.maximumValueFutureValue}
                      onChange={handleFutureValue}
                    />

                    {maximumValue?.maximumValueFutureValue > 0 && (
                      <input
                        // placeholder="Justify Value"
                        name="maximumValue"
                        type="text"
                        autoComplete="off"
                        className="narrowInputReason"
                        style={{
                          background:
                            maximumValue?.maximumValueFutureValue > 0
                              ? "#FFF"
                              : "#EFEFEF",
                        }}
                        value={maximumValue?.maximumValueJustify}
                        onChange={handleJustification}
                      />
                    )}
                  </div>
                  <Divider />
                  <div className="valueDisplay">
                    <Typography className="subHeading">
                      Storage Location
                      <span
                        style={{
                          color: "#C6003D",
                          margin: "4px",
                          fontSize: "18px",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <ValueDisplay
                      current={true}
                      disabled={true}
                      suggested={false}
                      future={false}
                      justification={false}
                      currentValue={responseData?.storage_location}
                    />
                    <input
                      // placeholder="Sloc"
                      name="Sloc"
                      type="text"
                      className="narrowInput"
                      autoComplete="off"
                      value={location}
                      onChange={handleChangeCurrent}
                    />
                  </div>
                  <Divider />
                  <div className="valueDisplay">
                    <Typography className="subHeading">Bin</Typography>
                    <ValueDisplay
                      current={true}
                      disabled={true}
                      suggested={false}
                      future={false}
                      justification={false}
                      currentValue={responseData?.storage_bin}
                    />
                    <input
                      // placeholder="Bin"
                      name="Bin"
                      type="text"
                      className="narrowInput"
                      autoComplete="off"
                      value={bin}
                      onChange={handleChangeCurrent}
                    />
                  </div>
                  <Divider />

                  <Typography
                    sx={{
                      width: "100%",
                      fontFamily: "Verdana",

                      margin: "20px 0px 0px 0px",
                      fontWeight: "700",
                      position: "relative",
                      // left: "10px",
                      fontFamily: "Verdana",
                    }}
                  >
                    Equipment Number(s) For BOM
                    <span
                      style={{
                        color: "#C6003D",
                        margin: "4px",
                        fontSize: "18px",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "24.7%",
                      }}
                    >
                      {Array.from({ length: inputCount }).map((_, index) => (
                        <input
                          key={index}
                          className="partInputFieldEq"
                          type="text" // Change type to text
                          pattern="[0-9]*"
                          inputmode="numeric"
                          autoComplete="off"
                          value={inputValues[index]}
                          onChange={(e) =>
                            handleInputChange(index, e.target.value)
                          }
                          minLength="0" // Change min to minLength
                          maxLength="10" // Assuming you want to limit the length of input
                        />
                      ))}
                    </div>
                    <IconButton
                      onClick={handleAddInput}
                      sx={{ height: "40px" }}
                    >
                      <ButtonPlus />
                    </IconButton>
                  </div>

                  {/* <div style={inputStyle}>
                      <Typography style={headingStyle}>Existing Active Part</Typography>
                      <input
                        placeholder="Enter"
                        name="activePart"
                        onChange={handleChange}
                        type="text"
                        style={{ width: "25%" }}
                        // value={values.password}
                        className="partInputField"
                      />
                    </div>
                    <div style={inputStyle}>
                      <Typography style={headingStyle}>Comments</Typography>
                      <textarea
                        id="yourTextarea"
                        name="yourTextarea"
                        placeholder="Enter Comments"
                        // value={text}
                        style={{ width: "50%" }}
                        onChange={handleChange}
                        className="partTextField"
                        rows={4}
                        cols={50}
                      />
                    </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      type="submit"
                      className="submitButton"
                      style={{
                        fontSize: 16,
                        cursor: submitButton ? "pointer" : "default",
                        position: "relative",
                        fontFamily: "Verdana",
                        background: !submitButton ? "#f5f5f5" : "#C6003D",
                        color: submitButton ? "#FFFFFF" : "#C6003D",
                      }}
                      disabled={!submitButton}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      Submit
                    </button>
                    <button
                      type="submit"
                      className="cancelButton"
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        position: "relative",
                        fontFamily: "Verdana",
                      }}
                      onClick={(e) => {
                        handleReset();
                      }}
                    >
                      Reset
                    </button>
                    <button
                      type="submit"
                      className="cancelButton"
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        position: "relative",
                        fontFamily: "Verdana",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleBackClick();
                        handleReset();
                        // handleClose();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {loading ? (
                    <>
                      <Box sx={{ display: "flex" }}>
                        <CircularProgress style={{ color: "#C6003D" }} />
                      </Box>
                    </>
                  ) : (
                    <>
                      {/* <div>
                        <Box
                          sx={{
                            m: 1,
                            width: "100%",
                            borderRadius: "18px",
                            height: 280,
                            margin: "auto",
                          }}
                        >
                          <Paper elevation={1}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <div>
                                <Typography
                                  sx={{
                                    fontSize: "24px",
                                    fontWeight: "500",
                                    margin: "30px 0px 0px 100px",
                                  }}
                                >
                                  {" "}
                                  Successfully Submitted Part Extension Request{" "}
                                </Typography>
                              </div>
                              <Divider />
                              <div>
                                <Typography
                                  sx={{
                                    fontSize: "24px",
                                    margin: "30px 0px 0px 100px",
                                    borderRadius: "8px",
                                    width: "100%",
                                    padding: "10px",
                                  }}
                                >
                                  {" "}
                                  Request ID: #{requestID}{" "}
                                </Typography>
                              </div>
                            </div>
                          </Paper>
                        </Box>
                      </div> */}
                      <PartExtensionSuccess
                        partCreationDialog={partCreationDialog}
                        setPartCreationDialog={setPartCreationDialog}
                        requestID={requestID}
                        handleDialogOpen={handleDialogOpen}
                      />
                    </>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PartExtension;
